module.exports = __webpack_public_path__ + "static/media/invoice-header.99ae89dc.png";